import React from 'react';
import { Alert } from 'antd';

export function InlineNotification({ value, message, type, ...props }) {
  if (type === 'success') {
    return (
      <Alert
        className='success-notification'
        message={`Success: ${message}`}
        type={type}
        showIcon
        closable
        banner
      />
    );
  }
  if (type === 'error') {
    return (
      <Alert
        className='error-notification'
        message={`Error: ${message}`}
        type={type}
        showIcon
        closable
        banner
      />
    );
  }
  return (
    <Alert
      className='info-notification'
      message={`Info: ${message}`}
      type={type}
      showIcon
      closable
      banner
    />
  );
}
